export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'center',
    width: 90,
    fixed: 'left',
    slots: { default: 'opt' },
  },
  {
    field: 'erpOrderNo',
    title: 'ERP订单号',
    align: 'center',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'orderStatusCode',
    title: '订单状态码',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'orderStatusDesc',
    title: '订单状态',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'syncApiType',
    title: '同步数据接口类型',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'syncStatus',
    title: '同步状态',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    slots: {
      default: 'syncStatus',
    },
  },
  {
    field: 'syncTime',
    title: '上报处理时间',
    align: 'center',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'replyStatus',
    title: '远端返回状态',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    slots: {
      default: 'replyStatus',
    },
  },
  {
    field: 'replyTime',
    title: '远端处理返回时间',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'orderStatusLocation',
    title: '状态发生地点',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'creationTime',
    title: '创建时间',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'updatedTime',
    title: '修改时间',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
